<template>
  <div style="width: 100%">
    <div class="dataTime">
      <span class="demonstration">{{$t('common.date')}}</span>
      <el-date-picker
        v-model="dateTime"
        value-format="yyyy-MM-dd"
        type="date"
        :placeholder="$t('common.btn.choseDate')"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <el-row :gutter="20" class="echart-all">
      <el-col :span="12" style="padding-left: 0; padding-right: 0">
        <div class="all-left">
          <div class="left-title">{{$t('SafeManagement.checkRatio')}}</div>
          <div v-loading="pieLoading">
            <linegraph
              :id="'piegraph'"
              :data="optionPie"
              style="height: 300px"
            ></linegraph>
          </div>
        </div>
      </el-col>
      <el-col :span="12" style="padding-right: 0">
        <div class="all-left">
          <div class="left-title">{{$t('SafeManagement.checkAbnormalRatio')}}</div>
          <div v-loading="isLoading">
            <linegraph
              :id="'piegraphs'"
              :data="option"
              style="height: 300px"
            ></linegraph>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="dataTable">
      <div class="table-title">{{$t('SafeManagement.queryCheckRecord')}}</div>
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('common.num')">
            <el-select
              v-model="formInline.selectCarType"
              style="width: 120px"
              :placeholder="$t('common.choseTip')"
              class="selectStyle"
            >
              <el-option
                v-for="item in optionsInput"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              size="mini"
              v-model="formInline.selectCarValue"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="inputStyle"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('SafeManagement.carUseState')">
            <el-select
              v-model="formInline.carUseState"
              :placeholder="$t('SafeManagement.form.carUseState')"
              filterable
              size="mini"
              style="width: 150px"
            >
              <el-option
                v-for="item in UseStateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SafeManagement.InspectionResults')">
            <el-select
              v-model="formInline.isWarningType"
              :placeholder="$t('SafeManagement.abnormalState')"
              filterable
              size="mini"
              style="width: 150px"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
        >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('CHECKANALYSIS_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="options"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
    <el-dialog
      width="70%"
      class="addDialong"
      :title="$t('common.btn.operateDetail')"
      :visible.sync="dialogDetailsFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="DetailsRorm" :model="DetailsRorm">
        <div style="display: flex">
          <div style="width: 50%; height: 400px">
            <div style="border-bottom: 1px solid #c6cad2; margin-bottom: 10px">
              {{$t('SafeManagement.checkName')}}</div>
            <el-scrollbar>
              <el-form-item
                prop="carId"
                :label="item.checkName"
                :label-width="formLabelWidth"
                v-for="(item, index) in DetailsRorm.radioList"
                :key="index"
              >
                <div>
                  <el-radio-group
                    disabled
                    v-model="item.isWarning"
                    class="radioStyle"
                  >
                    <el-radio :label="0">{{$t('common.normal')}}</el-radio>
                    <el-radio :label="1">{{$t('common.abnormal')}}</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
            </el-scrollbar>
          </div>
          <div style="width: 50%; margin-left: 20px">
          <el-form-item prop="carUseState" :label="$t('SafeManagement.carUseState')+':'">
            <el-select
              v-model="DetailsRorm.carUseState"
              :placeholder="$t('SafeManagement.form.carUseState')"
              filterable
              class="textareaStyle"
              disabled
            >
              <el-option
                v-for="item in UseStateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="carMileage" :label="$t('SafeManagement.carMileage')">
            <el-input
              size="small"
              v-model="DetailsRorm.carMileage"
              autocomplete="off"
              disabled
              class="textareaStyle"
            ></el-input>
          </el-form-item>
          <el-form-item prop="remarks" :label="$t('common.remark')">
            <el-input
              size="small"
              v-model="DetailsRorm.remarks"
              autocomplete="off"
              type="textarea"
              :rows="4"
              disabled
              class="textareaStyle"
            ></el-input>
          </el-form-item>
          <el-form-item prop="filePath" :label="$t('common.picture')" class="imgStyle">
            <img width="178px" height="178px" :src="imageUrl" alt="" />
          </el-form-item>
        </div>
        </div>
        
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ChangeTime from "./ChangeTime";
export default ChangeTime;
</script>

<style>
.el-image-viewer__mask {
    background: rgba(255, 255, 255) !important;
    opacity: 1 !important;
}
</style>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
/deep/.el-table td.el-table__cell,
/deep/.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid rgba(180, 185, 209, 0.15);
  border-left: 1px solid rgba(180, 185, 209, 0.15);
}
/deep/.el-table td.el-table__cell:last-child,
/deep/.el-table th.el-table__cell.is-leaf:last-child {
  border-right: 1px solid rgba(180, 185, 209, 0.15);
}

</style>
